import AddLink from './add-link'

import withRedux from './with-redux'

export default withRedux(AddLink)